import squadsConfig from "./squads.config.json";
import teamsConfig from "./teams.config.json";

// --- Rutas y assets CDN ---

export const GUIA_MUNDIAL_BASE_PATH = "guia-completa-mundial-2026";

const GUIA_MUNDIAL_CDN =
  "https://www.clarin.com/collections/escudos/guiamundial";

export const GUIA_MUNDIAL_PORTADA_IMAGE =
  "https://images.clarin.com/collections/escudos/guiamundial/portada.webp";
export const GUIA_MUNDIAL_SEED_CARD_BG =
  "https://images.clarin.com/collections/escudos/guiamundial/bg-cabezas.png";

const ASSET_FOLDERS = {
  camiseta: "camisetas",
  capitan: "capitanes",
  capitanCabeza: "capitanes-cabezas",
  escudo: "escudos",
};

export const guiaMundialCollectionAsset = (folder, slug, extension = "webp") =>
  `${GUIA_MUNDIAL_CDN}/${folder}/${slug}.${extension}`;

export const GUIA_MUNDIAL_CAPTAIN_PLACEHOLDER = guiaMundialCollectionAsset(
  "capitanes-cabezas",
  "alemania"
);

export const guiaMundialPlayerImage = (teamSlug, fileName) =>
  `${GUIA_MUNDIAL_CDN}/jugadores/${teamSlug}/${fileName}`;

export const GUIA_MUNDIAL_TEAM_OVERRIDES = {
  "bosnia-y-herzegovina": {
    assetSlug: "bosnia-herzegovina",
  },
};

const slugToDisplayName = (slug) =>
  slug
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const getGuiaMundialTeamAssets = (assetSlug) => ({
  escudo: guiaMundialCollectionAsset(ASSET_FOLDERS.escudo, assetSlug),
  camiseta: guiaMundialCollectionAsset(ASSET_FOLDERS.camiseta, assetSlug),
  capitan: guiaMundialCollectionAsset(ASSET_FOLDERS.capitan, assetSlug),
  capitanCabeza: guiaMundialCollectionAsset(
    ASSET_FOLDERS.capitanCabeza,
    assetSlug
  ),
  jugadoresBaseUrl: `${GUIA_MUNDIAL_CDN}/jugadores/${assetSlug}`,
});

export const getGuiaMundialTeam = (countrySlug = "", players = []) => {
  if (!countrySlug) return null;

  const slug = countrySlug.split("/")[0]?.toLowerCase();
  const override = GUIA_MUNDIAL_TEAM_OVERRIDES[slug] ?? {};
  const assetSlug = override.assetSlug ?? slug;

  return {
    slug,
    assetSlug,
    name:
      override.name ??
      getCountryBySlug(slug)?.name ??
      slugToDisplayName(slug),
    assets: getGuiaMundialTeamAssets(assetSlug),
    image: guiaMundialCollectionAsset(ASSET_FOLDERS.escudo, assetSlug),
    players,
  };
};

export const formatGuiaMundialCountryLabel = (slug) =>
  slug ? getGuiaMundialTeam(slug)?.name ?? slug : "";

export const getGuiaMundialCountryPortadaCopy = (countryName) => ({
  title: `Selección de ${countryName} en el Mundial 2026: plantel, figuras y análisis`,
  lead: `Toda la información sobre la Selección de ${countryName} en el Mundial 2026: jugadores convocados, figuras, DT, claves y análisis completo del plantel.`,
});

export const getCountryCaptainSeedUrl = (countrySlug) => {
  const assets = getGuiaMundialTeam(countrySlug)?.assets;
  return (
    assets?.capitanCabeza ?? assets?.capitan ?? GUIA_MUNDIAL_CAPTAIN_PLACEHOLDER
  );
};

// --- Países y banderas ---

export const GUIA_MUNDIAL_FLAGS_BASE =
  "https://hatscripts.github.io/circle-flags/flags";

export const GUIA_MUNDIAL_PLACEHOLDER_FLAG = `${GUIA_MUNDIAL_FLAGS_BASE}/de.svg`;

export const circleFlagUrl = (flagCode) =>
  `${GUIA_MUNDIAL_FLAGS_BASE}/${flagCode}.svg`;

export const GUIA_MUNDIAL_COUNTRIES = [
  { slug: "alemania", name: "Alemania", flagCode: "de" },
  { slug: "arabia-saudita", name: "Arabia Saudita", flagCode: "sa" },
  { slug: "argelia", name: "Argelia", flagCode: "dz" },
  { slug: "argentina", name: "Argentina", flagCode: "ar" },
  { slug: "australia", name: "Australia", flagCode: "au" },
  { slug: "austria", name: "Austria", flagCode: "at" },
  { slug: "belgica", name: "Bélgica", flagCode: "be" },
  { slug: "bosnia-y-herzegovina", name: "Bosnia y Herzegovina", flagCode: "ba" },
  { slug: "brasil", name: "Brasil", flagCode: "br" },
  { slug: "cabo-verde", name: "Cabo Verde", flagCode: "cv" },
  { slug: "canada", name: "Canadá", flagCode: "ca" },
  { slug: "colombia", name: "Colombia", flagCode: "co" },
  { slug: "corea-del-sur", name: "Corea del Sur", flagCode: "kr" },
  { slug: "costa-de-marfil", name: "Costa de Marfil", flagCode: "ci" },
  { slug: "croacia", name: "Croacia", flagCode: "hr" },
  { slug: "curazao", name: "Curazao", flagCode: "cw" },
  { slug: "ecuador", name: "Ecuador", flagCode: "ec" },
  { slug: "egipto", name: "Egipto", flagCode: "eg" },
  { slug: "escocia", name: "Escocia", flagCode: "gb-sct" },
  { slug: "espana", name: "España", flagCode: "es" },
  { slug: "estados-unidos", name: "Estados Unidos", flagCode: "us" },
  { slug: "francia", name: "Francia", flagCode: "fr" },
  { slug: "ghana", name: "Ghana", flagCode: "gh" },
  { slug: "haiti", name: "Haití", flagCode: "ht" },
  { slug: "inglaterra", name: "Inglaterra", flagCode: "gb-eng" },
  { slug: "irak", name: "Irak", flagCode: "iq" },
  { slug: "iran", name: "Irán", flagCode: "ir" },
  { slug: "japon", name: "Japón", flagCode: "jp" },
  { slug: "jordania", name: "Jordania", flagCode: "jo" },
  { slug: "marruecos", name: "Marruecos", flagCode: "ma" },
  { slug: "mexico", name: "México", flagCode: "mx" },
  { slug: "noruega", name: "Noruega", flagCode: "no" },
  { slug: "nueva-zelanda", name: "Nueva Zelanda", flagCode: "nz" },
  { slug: "paises-bajos", name: "Países Bajos", flagCode: "nl" },
  { slug: "panama", name: "Panamá", flagCode: "pa" },
  { slug: "paraguay", name: "Paraguay", flagCode: "py" },
  { slug: "portugal", name: "Portugal", flagCode: "pt" },
  { slug: "qatar", name: "Qatar", flagCode: "qa" },
  { slug: "rd-congo", name: "RD Congo", flagCode: "cd" },
  { slug: "republica-checa", name: "República Checa", flagCode: "cz" },
  { slug: "senegal", name: "Senegal", flagCode: "sn" },
  { slug: "sudafrica", name: "Sudáfrica", flagCode: "za" },
  { slug: "suecia", name: "Suecia", flagCode: "se" },
  { slug: "suiza", name: "Suiza", flagCode: "ch" },
  { slug: "turquia", name: "Turquía", flagCode: "tr" },
  { slug: "tunez", name: "Túnez", flagCode: "tn" },
  { slug: "uruguay", name: "Uruguay", flagCode: "uy" },
  { slug: "uzbekistan", name: "Uzbekistán", flagCode: "uz" },
].sort((a, b) => a.name.localeCompare(b.name, "es"));

const countryBySlug = Object.fromEntries(
  GUIA_MUNDIAL_COUNTRIES.map((country) => [country.slug, country])
);

export const getCountryBySlug = (slug) => countryBySlug[slug?.toLowerCase()] ?? null;

/** Slugs alternativos → slug canónico (301 obligatorio). */
export const GUIA_MUNDIAL_SLUG_ALIASES = {
  congo: "rd-congo",
  "republica-democratica-del-congo": "rd-congo",
  usa: "estados-unidos",
  eeuu: "estados-unidos",
  "estados-unidos-de-america": "estados-unidos",
  holanda: "paises-bajos",
  corea: "corea-del-sur",
  arabia: "arabia-saudita",
  "arabia-saudi": "arabia-saudita",
  catar: "qatar",
  bosnia: "bosnia-y-herzegovina",
  boznia: "bosnia-y-herzegovina",
  "costa-marfil": "costa-de-marfil",
};

export const getGuiaMundialRedirectPath = (countrySlug = "") => {
  const normalized = countrySlug?.split("/")[0]?.toLowerCase().replace(/\.html$/i, "");
  if (!normalized || getCountryBySlug(normalized)) return null;

  const target = GUIA_MUNDIAL_SLUG_ALIASES[normalized];
  if (target && getCountryBySlug(target)) {
    return `/${GUIA_MUNDIAL_BASE_PATH}/${target}`;
  }
  return null;
};

export const getCountryFlagUrl = (country) => {
  if (!country?.flagCode) return GUIA_MUNDIAL_PLACEHOLDER_FLAG;
  return circleFlagUrl(country.flagCode);
};

// --- Grupos ---

export const GUIA_MUNDIAL_GROUPS = [
  {
    letter: "A",
    teams: [
      { slug: "mexico", isSeed: true },
      { slug: "sudafrica", isSeed: false },
      { slug: "corea-del-sur", isSeed: false },
      { slug: "republica-checa", isSeed: false },
    ],
  },
  {
    letter: "B",
    teams: [
      { slug: "canada", isSeed: true },
      { slug: "bosnia-y-herzegovina", isSeed: false },
      { slug: "qatar", isSeed: false },
      { slug: "suiza", isSeed: false },
    ],
  },
  {
    letter: "C",
    teams: [
      { slug: "brasil", isSeed: true },
      { slug: "marruecos", isSeed: false },
      { slug: "haiti", isSeed: false },
      { slug: "escocia", isSeed: false },
    ],
  },
  {
    letter: "D",
    teams: [
      { slug: "estados-unidos", isSeed: true },
      { slug: "paraguay", isSeed: false },
      { slug: "australia", isSeed: false },
      { slug: "turquia", isSeed: false },
    ],
  },
  {
    letter: "E",
    teams: [
      { slug: "alemania", isSeed: true },
      { slug: "curazao", isSeed: false },
      { slug: "costa-de-marfil", isSeed: false },
      { slug: "ecuador", isSeed: false },
    ],
  },
  {
    letter: "F",
    teams: [
      { slug: "paises-bajos", isSeed: true },
      { slug: "japon", isSeed: false },
      { slug: "suecia", isSeed: false },
      { slug: "tunez", isSeed: false },
    ],
  },
  {
    letter: "G",
    teams: [
      { slug: "belgica", isSeed: true },
      { slug: "egipto", isSeed: false },
      { slug: "iran", isSeed: false },
      { slug: "nueva-zelanda", isSeed: false },
    ],
  },
  {
    letter: "H",
    teams: [
      { slug: "espana", isSeed: true },
      { slug: "cabo-verde", isSeed: false },
      { slug: "arabia-saudita", isSeed: false },
      { slug: "uruguay", isSeed: false },
    ],
  },
  {
    letter: "I",
    teams: [
      { slug: "francia", isSeed: true },
      { slug: "senegal", isSeed: false },
      { slug: "irak", isSeed: false },
      { slug: "noruega", isSeed: false },
    ],
  },
  {
    letter: "J",
    teams: [
      { slug: "argentina", isSeed: true },
      { slug: "argelia", isSeed: false },
      { slug: "austria", isSeed: false },
      { slug: "jordania", isSeed: false },
    ],
  },
  {
    letter: "K",
    teams: [
      { slug: "portugal", isSeed: true },
      { slug: "rd-congo", isSeed: false },
      { slug: "uzbekistan", isSeed: false },
      { slug: "colombia", isSeed: false },
    ],
  },
  {
    letter: "L",
    teams: [
      { slug: "inglaterra", isSeed: true },
      { slug: "croacia", isSeed: false },
      { slug: "ghana", isSeed: false },
      { slug: "panama", isSeed: false },
    ],
  },
];

export const getGuiaMundialGroupLabel = (letter) => `Grupo ${letter}`;

const groupLetterBySlug = GUIA_MUNDIAL_GROUPS.reduce((acc, group) => {
  group.teams.forEach((team) => {
    acc[team.slug] = group.letter;
  });
  return acc;
}, {});

export const getGuiaMundialGroupLetterBySlug = (slug) =>
  groupLetterBySlug[slug?.toLowerCase()] ?? null;

// --- Plantel (squads.config.json) ---

const normalizePlayer = (player) => ({
  ...player,
  birthDate: player.birthDate?.replace(/"\s*$/, "") ?? null,
});

const mapPlayer = (teamSlug, player) => {
  const normalized = normalizePlayer(player);
  return {
    ...normalized,
    image: normalized.file
      ? guiaMundialPlayerImage(teamSlug, normalized.file)
      : null,
  };
};

export const getGuiaMundialSquad = (teamSlug = "") => {
  const slug = teamSlug?.split("/")[0]?.toLowerCase();
  if (!slug) return [];

  const sections = squadsConfig.squads?.[slug]?.sections ?? [];
  return sections.map((section) => ({
    title: section.title,
    players: (section.players ?? []).map((player) => mapPlayer(slug, player)),
  }));
};

// --- Ficha de equipo (teams.config.json) ---

export const GUIA_MUNDIAL_TEAM_ACCENT_COLORS = Object.fromEntries(
  Object.entries(teamsConfig.teams ?? {}).map(([slug, team]) => [
    slug,
    team.accentColor,
  ])
);

export const getGuiaMundialTeamAccentColor = (slug = "") => {
  const normalized = slug.split("/")[0]?.toLowerCase();
  return teamsConfig.teams?.[normalized]?.accentColor ?? "#ffffff";
};

export const getGuiaMundialTeamProfile = (slug) => {
  const normalized = slug?.split("/")[0]?.toLowerCase();
  if (!normalized) return null;

  const stored = teamsConfig.teams?.[normalized];
  const name =
    getCountryBySlug(normalized)?.name ??
    normalized
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  const groupLetter = getGuiaMundialGroupLetterBySlug(normalized);

  return {
    groupLetter,
    description:
      stored?.description ??
      `Información, plantel y análisis de la Selección de ${name} en el Mundial 2026.`,
    coach: stored?.coach ?? "A confirmar",
    fifaRanking: stored?.fifaRanking ?? "—",
    fortalezas: stored?.fortalezas ?? null,
    debilidades: stored?.debilidades ?? null,
    accentColor: stored?.accentColor ?? "#ffffff",
    numberTextColor: stored?.numberTextColor ?? "#ffffff",
  };
};

const GUIA_MUNDIAL_SCHEMA_SPORT =
  "https://en.wikipedia.org/wiki/Association_football";
const GUIA_MUNDIAL_SCHEMA_GENDER = "https://schema.org/Male";

const mapSquadPlayerToSchemaAthlete = (player) => {
  if (!player?.name || player.position === "DT") return null;

  const athlete = {
    "@type": "Person",
    name: player.name,
    jobTitle: player.position,
  };

  if (player.role && player.role !== player.position) {
    athlete.additionalName = player.role;
  }

  return athlete;
};

/** JSON-LD SportsTeam para la ficha de cada selección. */
export const buildGuiaMundialSportsTeamSchema = (
  team,
  baseUrl = process.env.NEXT_PUBLIC_DOMAIN_URL ?? "https://www.clarin.com"
) => {
  if (!team?.slug || !team?.name) return null;

  const athletes = (team.squad ?? [])
    .flatMap((section) => section.players ?? [])
    .map(mapSquadPlayerToSchemaAthlete)
    .filter(Boolean);

  const coachName = team.profile?.coach;
  const schema = {
    "@context": "https://schema.org",
    "@type": "SportsTeam",
    name: `Selección de fútbol de ${team.name}`,
    sport: GUIA_MUNDIAL_SCHEMA_SPORT,
    gender: GUIA_MUNDIAL_SCHEMA_GENDER,
    url: `${baseUrl.replace(/\/$/, "")}/${GUIA_MUNDIAL_BASE_PATH}/${team.slug}`,
    logo: team.assets?.escudo ?? team.image,
    memberOf: {
      "@type": "SportsOrganization",
      name: "FIFA",
    },
    athlete: athletes,
  };

  if (coachName) {
    schema.coach = {
      "@type": "Person",
      name: coachName,
      jobTitle: "Entrenador",
    };
  }

  return schema;
};
